/* eslint-disable max-len */
import { BACKEND_IDS } from '../../../services/ApiConfig';
import { getIdleNotifyMs, getIdleTimerShowSeconds, getRefreshTokenIntervalSeconds } from '../../../utils/helpers/refreshIntervalConfig';
import {
  REACT_APP_URL_GLOBAL_PARAMS_FIND,
  REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_CUSTOM_PAYROLL_TYPE,
  REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_DICTIONARY,
  REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_MARITAL_STATUS,
  REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_ORG_DEPARTMENT,
  REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_RELEASE_NOTE,
  REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_TAX_PARAMS,
  REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_ZIP_CODE,
  REACT_APP_URL_V2_GLOBAL_PARAMS_FIND
} from '../Routes/URLs';

// date format constant
export const DATE_FORMAT = 'MM/DD/YYYY';

// date format constant for api calls (MM/DD/YYYY) for a reports configuration
export const DATE_FORMAT_API = 'MM/DD/YYYY';

// date format constant for api calls (YYYY/MM/DD) for a reports configuration
export const DATE_FORMAT_API_GENERATE = 'YYYY-MM-DD';

// country default EEUU
export const DEFAULT_COUNTRY = 234;

export const IDLE_SESSION_TIMEOUT_MS = getIdleNotifyMs();

export const IDLE_WARNING_THRESHOLD_SECONDS = getIdleTimerShowSeconds();

export const PROACTIVE_REFRESH_INTERVAL_SECONDS = getRefreshTokenIntervalSeconds();

/** @deprecated use IDLE_SESSION_TIMEOUT_MS */
export const TIME_OUT_TO_NOTIFY_IN_MILISECONDS = IDLE_SESSION_TIMEOUT_MS;
/** @deprecated use IDLE_WARNING_THRESHOLD_SECONDS */
export const TIME_TO_SHOW_THE_TIMER_IN_SECONDS = IDLE_WARNING_THRESHOLD_SECONDS;
/** @deprecated use PROACTIVE_REFRESH_INTERVAL_SECONDS */
export const REFRESH_TOKEN_INTERVAL_IN_SECONDS = PROACTIVE_REFRESH_INTERVAL_SECONDS;
export const MAIN_OFFICE_NAME = 'MAIN OFFICE';
export const MAIN_BRANCH_NAME = 'MAIN BUILDING';

// constans headers custom payroll
export const initialCodeHeaders = [51, 27, 17];

// update files for type
export const fileType = [
  { type: 'Job application' },
  { type: 'Resume' },
  { type: 'Job offer - signed contract' },
  { type: 'W4' },
  { type: 'Signed employee handbook' },
  { type: 'Performance reviews' },
  { type: 'Training' },
  { type: 'Warnings - disciplinary action' },
  { type: 'Non-compete' },
  { type: 'Resignation letter' },
  { type: 'Insurance docs' },
  { type: 'Drivers Lisc' },
  { type: 'I9' },
  { type: '401k communication - receipt' },
  { type: 'Ins communication - receipt ' },
  { type: 'Background check' },
  { type: 'E verify' },
  { type: 'DMV checks' },
  { type: 'Forklift Certificates - Card' },
  { type: 'Drug test results or if completed' },
  { type: 'Injury claim' }
];

export const fileTypeClient = [{ type: 'Company Info' }, { type: 'Contracts' }, { type: 'Prior Assignments' }];

/**
 * Global parameters list.
 * BE2 save endpoints expect `{ [saveListField]: rows }` (SaveGlobal*Request), not a bare array.
 */
export const globalparameterlist = [
  {
    id: 1,
    label: 'Payroll Type',
    key: 'com.tempedge.global.param.custompayrolltype',
    find: REACT_APP_URL_V2_GLOBAL_PARAMS_FIND,
    save: REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_CUSTOM_PAYROLL_TYPE,
    saveListField: 'customPayrollTypeList',
    findBackendType: BACKEND_IDS.BACKEND_2,
    saveBackendType: BACKEND_IDS.BACKEND_2
  },
  {
    id: 2,
    label: 'Time Off Type',
    // Not migrated on BE2 find yet ("Invalid global parameter type"); keep BE1 like develop.
    key: 'com.tempedge.global.param.timeofftype',
    find: REACT_APP_URL_GLOBAL_PARAMS_FIND,
    save: '/api/globalParams/saveTimeOffType',
    findBackendType: BACKEND_IDS.BACKEND_1,
    saveBackendType: BACKEND_IDS.BACKEND_1
  },
  {
    id: 3,
    label: 'Marital Status Type',
    key: 'com.tempedge.global.param.maritalstatus',
    find: REACT_APP_URL_V2_GLOBAL_PARAMS_FIND,
    save: REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_MARITAL_STATUS,
    saveListField: 'maritalStatusList',
    findBackendType: BACKEND_IDS.BACKEND_2,
    saveBackendType: BACKEND_IDS.BACKEND_2
  },
  {
    id: 4,
    label: 'Release Notes',
    key: 'com.tempedge.global.param.releasenotes',
    find: REACT_APP_URL_V2_GLOBAL_PARAMS_FIND,
    save: REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_RELEASE_NOTE,
    saveListField: 'releaseNotesList',
    omitRowFields: ['orgId'],
    findBackendType: BACKEND_IDS.BACKEND_2,
    saveBackendType: BACKEND_IDS.BACKEND_2
  },
  {
    id: 5,
    label: 'Dictionary',
    key: 'com.tempedge.global.param.dictionary',
    find: REACT_APP_URL_V2_GLOBAL_PARAMS_FIND,
    save: REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_DICTIONARY,
    saveListField: 'dictionaryList',
    findBackendType: BACKEND_IDS.BACKEND_2,
    saveBackendType: BACKEND_IDS.BACKEND_2
  },
  {
    id: 6,
    label: 'Tax Params',
    key: 'com.tempedge.global.param.taxes',
    find: REACT_APP_URL_V2_GLOBAL_PARAMS_FIND,
    save: REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_TAX_PARAMS,
    saveListField: 'taxParamsList',
    findBackendType: BACKEND_IDS.BACKEND_2,
    saveBackendType: BACKEND_IDS.BACKEND_2
  },
  {
    id: 7,
    label: 'Zip Code',
    key: 'com.tempedge.global.param.zip_code',
    find: REACT_APP_URL_V2_GLOBAL_PARAMS_FIND,
    save: REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_ZIP_CODE,
    saveListField: 'zipCodeList',
    findBackendType: BACKEND_IDS.BACKEND_2,
    saveBackendType: BACKEND_IDS.BACKEND_2
  },
  {
    id: 8,
    label: 'Org Department',
    key: 'com.tempedge.global.param.orgdepartment',
    find: REACT_APP_URL_V2_GLOBAL_PARAMS_FIND,
    save: REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_ORG_DEPARTMENT,
    saveListField: 'orgDepartmentList',
    findBackendType: BACKEND_IDS.BACKEND_2,
    saveBackendType: BACKEND_IDS.BACKEND_2
  }
];

export const sizePagesList = 30;

// diferent status marital
export const shiftList = [
  { shiftNameKey: 'com.tempedge.msg.label.1st', shiftId: 1 },
  { shiftNameKey: 'com.tempedge.msg.label.2nd', shiftId: 2 },
  { shiftNameKey: 'com.tempedge.msg.label.3rd', shiftId: 3 }
];

export const titleDeptPosKey = 'com.tempedge.msg.label.deptpos';

export const maxValuesSelected = {
  status: 200,
  code: 'TE-E08',
  message: 'com.tempedge.warn.maxvaluescustompayroll'
};
export const customSuccess = {
  status: 200,
  code: 'TE00',
  message: 'com.tempedge.msg.info.msg.success'
};
export const errorOnCustomPayroll = {
  status: 400,
  code: 'TE-00',
  message: 'com.tempedge.error.errorcustompayroll'
};

export const MAX_HOURS_PER_WEEK = 40;
